<template>
	<article class="my_order_page">
		<!--<article class="home">-->
		<modal title="操作提示" v-model="refundModal.Show" :mask-closable="false" @on-ok="applyRefund(refundModal.Order)">
			<p v-if="refundModal.Type == 1">
				非会员班车发车前2小时（不含2小时）退票需收取10%退票费；非会员班车发车前2小时以内退票需收取20%退票费；非会员发车后退票，视为占座不作退票。是否需要退票？
			</p>
			<p v-else-if="refundModal.Type == 2">若客服已确认订单,则订单不可退款,若订单未确认,则可手动操作订单退款,是否需要退款并取消订单?</p>
		</modal>
		<modal title="操作提示" v-model="cancelModal.Show" :mask-closable="false" @on-ok="cancelOrder(cancelModal.Order)">
			<p v-if="cancelModal.Type == 1">是否确认要取消订单，若取消订单，已锁定的座位将被释放，下单后10分钟内没完成支付操作将会自动取消订单，请问是否要立即取消订单释放座位？</p>
			<p v-else-if="cancelModal.Type == 2">是否确认要取消订单?</p>
		</modal>

		<section class="my_order_list">
			<ul class="swiperTab">
				<li :class="currentTab == 0 ? 'order_swiperTab_item active' : 'order_swiperTab_item'" @click="changeTab(0)">机场大巴</li>
				<li :class="currentTab == 1 ? 'order_swiperTab_item active' : 'order_swiperTab_item'" @click="changeTab(1)">商城业务</li>
				<li :class="currentTab == 2 ? 'order_swiperTab_item active' : 'order_swiperTab_item'" @click="changeTab(2)">候机楼专车</li>
			</ul>

			<div class="swiper-container tab_swiper">
				<div class="swiper-wrapper">
					<!-- TicketOrderList Start   -->
					<template v-if="currentTab == 0">
						<div class="swiper-slide">
							<div class="record_list_wrap" style="width: 100%;display: block;">
								<template v-for="(orderItem, index, key) in orderList">
									<div :key="key" class="record_wrap" @click="showOrderDetail(orderItem)" style="width: 94%;margin: 10px auto 0;">
										<div class="record_title">
											<p class="white_color">
												<span>订单号 :</span>
												<span>{{ orderItem.OrderNum }}</span>
											</p>
											<p class="white_color">
												<span>订单状态 :</span>
												<span>{{ orderState[orderItem.OrderState] }}</span>
											</p>
										</div>
										<div class="record_conrainer">
											<p>
												<span>订单类型 :</span>
												<span v-if="orderItem.OrderType == 1">机场大巴</span>
												<span v-else-if="orderItem.OrderType == 2">接送购票</span>
												<span v-else-if="orderItem.OrderType == 3">返程预约</span>
												<span v-else-if="orderItem.OrderType == 4">机场包车</span>
											</p>
											<p>
												<span>乘客数 :</span>
												<span>{{ orderItem.Adult + orderItem.Child + orderItem.Baby }}人</span>
											</p>

											<p>
												<span>出发站点 :</span>
												<span>{{ orderItem.GetOn }}</span>
											</p>

											<p>
												<span>出发时间:</span>
												<span>{{ orderItem.OrderType != 4 ? orderItem.FreTime : orderItem.SetDate }}</span>
											</p>

											<p>
												<span>到达站点 :</span>
												<span>{{ orderItem.GetOff }}</span>
											</p>

											<p v-if="orderItem.OrderType == 2 || orderItem.OrderType == 3 || orderItem.OrderType == 4">
												<span>接送地址 :</span>
												<span class="text_wrapping">{{ orderItem.AppointAddress }}</span>
											</p>

											<p v-if="orderItem.OrderType == 2">
												<span>预约时间 :</span>
												<span class="text_wrapping">{{ orderItem.AppointTime == null ? '--待客服确认-- ' : orderItem.AppointTime }}</span>
											</p>
											<p v-else-if="orderItem.OrderType == 3 || orderItem.OrderType == 4">
												<span>预约时间 :</span>
												<span class="text_wrapping">{{ orderItem.OrderCheck == false ? '--待客服确认-- ' : orderItem.SetDate }}</span>
											</p>

											<p v-if="orderItem.OrderType == 2 || orderItem.OrderType == 3 || orderItem.OrderType == 4">
												<span>司机电话 :</span>
												<span class="text_wrapping">{{ orderItem.DriverMobile == null ? '--待客服确认-- ' : orderItem.DriverMobile }}</span>
											</p>

											<p v-if="orderItem.OrderType == 4">
												<span>客户备注 :</span>
												<span class="text_wrapping">{{ orderItem.Remarks }}</span>
											</p>

											<p v-if="orderItem.OrderType == 2"><span class="red_color">*当天12：30以前的接送服务，在乘车前一天下午18:00左右通知上门时间</span></p>
											<p v-if="orderItem.OrderType == 2"><span class="red_color">*当天12：30以后的接送服务，在乘车当天早上10:00左右通知上门时间</span></p>
										</div>
										<div class="order_list_foot flex_wrap j_c_between">
											<p>
												<span>{{ orderItem.CreateDate }}</span>
											</p>
											<p>
												<span>订单总金额 :</span>
												<span class="red-text">&yen;{{ orderItem.TotalPrice }}</span>
											</p>
										</div>

										<div class="my_order_function_btns" v-if="orderItem.OrderState == 0 && orderItem.Status">
											<button
												class="little_btn function_btn_pj_color"
												@click.stop="(cancelModal.Show = true), (cancelModal.Order = orderItem), (cancelModal.Type = 1)"
											>
												<i class="iconfont icon-shanchu1"></i>
												取消{{ orderItem.OrderType == 4 ? '预约' : '订单' }}
											</button>
											<button class="little_btn function_btn_wx_color" @click.stop="paymentOrder(orderItem, 1)">
												<i class="iconfont icon-zhifu"></i>
												继续支付
											</button>
										</div>

										<div class="my_order_function_btns" v-if="orderItem.OrderState == 1">
											<button	class="little_btn function_btn_pj_color" @click.stop="(refundModal.Show = true),(refundModal.Order = orderItem),orderItem.OrderType == 4 ? (refundModal.Type = 2) : (refundModal.Type = 1)">
												<i class="iconfont icon-tuikuan1"></i>
												申请退票
											</button>
										</div>

										<!-- 温馨提示 -->
										<div v-if="orderItem.OrderState == 0 && orderItem.Status" class="warm-prompt">
											<p v-if="orderItem.OrderType != 4"><span>请于下单后10分钟内完成支付!</span></p>
											<p v-else><span>请尽快完成支付！</span></p>
										</div>
										<div v-if="orderItem.OrderState == 1 && orderItem.OrderType != 4" class="warm-prompt">
											<p class="red-text">若需要退票请于发车前2小时申请退票!</p>
										</div>
									</div>
								</template>
							</div>
						</div>
					</template>
					<!-- TicketOrderList End   -->

					<!-- ScopeOrderList Start   -->
					<template v-if="currentTab == 1">
						<div class="swiper-slide">
							<div class="record_list_wrap" style="width: 100%;display: block;">
								<template v-for="(orderItem, index, key) in scopeOrderList">
									<div :key="key" class="record_wrap" @click="showScopeOrderDetail(orderItem)" style="width: 94%;margin: 10px auto 0;">
										<div class="record_title">
											<p class="white_color">
												<span>订单号 :</span>
												<span>{{ orderItem.OrderNum }}</span>
											</p>
											<p class="white_color">
												<span>订单状态 :</span>
												<span>{{ orderState[orderItem.OrderState] }}</span>
											</p>
										</div>
										<div class="record_conrainer">
											<p>
												<span>订单类型 :</span>
												<span v-if="orderItem.OrderType == 1">业务商品订单</span>
												<span v-else-if="orderItem.OrderType == 2">预约业务订单</span>
											</p>
											<p>
												<span>订单人数 :</span>
												<span>{{ orderItem.Adult + orderItem.Child + orderItem.Baby }}人</span>
											</p>

											<p>
												<span>业务名称 :</span>
												<span>{{ orderItem.ScopeGoodsName }}</span>
											</p>

											<p>
												<span>预定时间:</span>
												<span>{{ orderItem.SetDate }}</span>
											</p>

											<p v-if="orderItem.OrderType == 2">
												<span>预约地址 :</span>
												<span class="text_wrapping">{{ orderItem.Address }}</span>
											</p>
											<p>
												<span>确认状态 :</span>
												<span class="text_wrapping">{{ orderItem.OrderCheck == true ? '客服已确认订单' : '--待客服确认--' }}</span>
											</p>
											<p>
												<span>客户备注 :</span>
												<span class="text_wrapping">{{ orderItem.OrderRemarks }}</span>
											</p>
										</div>
										<div class="order_list_foot">
											<p>
												<span>{{ orderItem.CreateDate }}</span>
											</p>
											<p>
												<span>订单总金额 :</span>
												<span class="red-text">&yen;{{ orderItem.TotalPrice }}</span>
											</p>
										</div>

										<div class="my_order_function_btns" v-if="orderItem.OrderState == 0 && orderItem.Status">
											<button
												class="little_btn function_btn_pj_color"
												@click.stop="(cancelModal.Show = true), (cancelModal.Order = orderItem), (cancelModal.Type = 2)"
											>
												<i class="iconfont icon-shanchu1"></i>
												取消{{ orderItem.OrderType == 4 ? '预约' : '订单' }}
											</button>
											<button class="little_btn function_btn_wx_color" @click.stop="paymentOrder(orderItem, 2)">
												<i class="iconfont icon-zhifu"></i>
												继续支付
											</button>
										</div>

										<div class="my_order_function_btns" v-if="orderItem.OrderState == 1 && orderItem.OrderType != 4">
											<button
												class="little_btn function_btn_pj_color"
												@click.stop="(refundModal.Show = true), (refundModal.Order = orderItem), (refundModal.Type = 2)"
											>
												<i class="iconfont icon-tuikuan1"></i>
												申请取消订单
											</button>
										</div>

										<!-- 温馨提示 -->
										<div v-if="orderItem.OrderState == 0 && orderItem.Status" class="warm-prompt">
											<p class="red-text"><span>请于下单后30分钟内完成支付!</span></p>
										</div>
									</div>
								</template>
							</div>
						</div>
					</template>
					<!-- ScopeOrderList End   -->

					<!-- AppointOrderList Start   -->
					<template v-if="currentTab == 2">
						<div class="swiper-slide">
              <!-- <div class="record_list_wrap flex_wrap column" style="width: 100%;display: block;"> -->
							<div class="record_list_wrap" style="width: 100%;display: block;">
								<template v-for="(orderItem, key, index) in appointOrderList">
									<div class="record_wrap" @click="showAppointOrderDetail(orderItem)" :key="key + index" style="width: 94%;margin: 10px auto 0;">
										<div class="record_title flex_wrap j_c_between ">
											<p class="white_color">
												<span>订单号 :</span>
												<span>{{ orderItem.OrderNum }}</span>
											</p>
											<p class="white_color">
												<span>订单状态 :</span>
												<span>{{ orderState[orderItem.OrderState] }}</span>
											</p>
										</div>
										<div class="record_conrainer">
											<p>
												<span>上车地点 :</span>
												<span>{{ orderItem.bookingStartAddr }}</span>
											</p>

											<p>
												<span>下车地点 :</span>
												<span>{{ orderItem.bookingEndAddr }}</span>
											</p>

											<p>
												<span>预约时间:</span>
												<span>{{ orderItem.bookingDate }}</span>
											</p>
											<p>
												<span>客户备注 :</span>
												<span class="text_wrapping">{{ orderItem.UserRemarks }}</span>
											</p>
										</div>
										<div class="order_list_foot flex_wrap j_c_between">
											<p>
												<span>{{ orderItem.CreateDate }}</span>
											</p>
											<p>
												<span>订单总金额 :</span>
												<span class="red_color">&yen;{{ orderItem.TotalPrice }}</span>
											</p>
										</div>

										<div class="my_order_function_btns flex_wrap a_i_center j_c_end" v-if="orderItem.OrderState == 0 && orderItem.Status">
											<button
												class="little_btn function_btn_pj_color"
												@click.stop="(cancelModal.Show = true), (cancelModal.Order = orderItem), (cancelModal.Type = 2)"
											>
												<i class="iconfont icon-shanchu1"></i>
												取消预约
											</button>
											<button class="little_btn function_btn_wx_color" @click.stop="paymentOrder(orderItem, 3)">
												<i class="iconfont icon-zhifu"></i>
												继续支付
											</button>
										</div>

										<div
											class="my_order_function_btns flex_wrap a_i_center j_c_end"
											v-if="orderItem.OrderState == 1 && orderItem.OrderType != 1 && orderItem.OrderType != 2"
										>
											<button
												class="little_btn function_btn_pj_color"
												@click.stop="(refundModal.Show = true), (refundModal.Order = orderItem), (refundModal.Type = 2)"
											>
												<i class="iconfont icon-tuikuan1"></i>
												申请取消订单
											</button>
										</div>

										<div v-if="orderItem.OrderState == 0 && orderItem.Status" class="warm-prompt">
											<p class="red-text"><span>请于下单后30分钟内完成支付!</span></p>
										</div>
									</div>
								</template>
							</div>
						</div>
					</template>
					<!-- AppointOrderList End   -->
				</div>
			</div>
		</section>
	</article>
</template>

<script>
import orderApi from '../request/orderApi';
import paymentApi from '../request/paymentApi';
import baseTool from '../utils/baseFunction';
import QRCode from '../utils/qrcode.min';

export default {
	name: 'MyOrderList',
	data() {
		return {
			orderList: [],
			scopeOrderList: [],
			appointOrderList: [],
			currentTab: 0,
			orderState: ['待支付', '已支付', '已完成', '发起退款', '退款成功', '等待回访'],
			count: 15,
			refundModal: {
				Show: false,
				Order: null,
				Type: null
			},
			cancelModal: {
				Show: false,
				Order: null,
				Type: null
			}
		};
	},
	mounted() {
		this.myTimer = setInterval(() => {
			if (this.$store.state.user.OpenId && this.$store.state.user.OpenId.length > 0) {
				clearInterval(this.myTimer);
				this.getOrderList();
			}
		}, 1000);
		// this.getOrderList();
	},
	methods: {
		getOrderList() {
			let that = this;
			let targetpage = 1;
			let count = this.count;
			this.orderList = [];
			this.$Spin.show();
			orderApi.getTicketOrderList(this.$store.state.user.OpenId, targetpage, count).then(sucRes => {
				this.getScopeOrderList();
				if (sucRes.success && sucRes.data !== null && sucRes.data.length > 0) {
					if (targetpage == 1) {
						for (let i = 0; i < sucRes.data.length; i++) {
							if (sucRes.data[i].Status) {
								this.changeTabByOrder(sucRes.data[i]);
								this.orderList = [];
								break;
							}
						}
					}
					sucRes.data.forEach(val => {
						val.CreateDate = baseTool.formatDateStr(val.CreateDate, 'full');
						if (val.AppointTime) {
							val.AppointTime = baseTool.formatDateStr(val.AppointTime, 'full');
						}
						val.SetDate = val.OrderType != 4 ? baseTool.formatDateStr(val.SetDate, 'date') : baseTool.formatDateStr(val.SetDate, 'full');
						if (val.FreTime) {
							val.FreTime = baseTool.formatDateStr(val.FreTime, 'full');
						}
						val.OrderList_InfoList.forEach(info => {
							info.IsShowTicket = false;
							info.ShowFrequency = false;
							if (info.QRCodeBase64 != '') {
								info.QRCodeBase64 = 'data:image/png;base64,' + info.QRCodeBase64;
							}
							info.OrderList_InfoFrequencyList.forEach(fre => {
								fre.SetTime = baseTool.formatDateStr(fre.SetTime, 'full');
							});
						});
					});
					this.orderList = sucRes.data;
				}
			});
		},
		getScopeOrderList() {
			let that = this;
			this.scopeOrderList = [];
			orderApi.getScopeOrderList(this.$store.state.user.OpenId, 1, 15).then(sucRes => {
				this.getAppointOrderList();
				let result = sucRes;
				if (result.success) {
					result.data.forEach(val => {
						val.CreateDate = baseTool.formatDateStr(val.CreateDate, 'full');
						val.SetDate = baseTool.formatDateStr(val.SetDate, 'full');
					});
					that.scopeOrderList = result.data;
				}
				// that.$Spin.hide();
				// that.changeTabByOrder(that.orderList.length > 0 ? that.orderList[0] : null, that.scopeOrderList.length > 0 ? that.scopeOrderList[0] : null);
			});
		},
		getAppointOrderList() {
			this.appointOrderList = [];
			orderApi.getAppointOrderList(this.$store.state.user.OpenId, 1, 15).then(sucRes => {
				this.$Spin.hide();
				let result = sucRes;
				if (result.success) {
					result.data.forEach(val => {
						val.CreateDate = baseTool.formatDateStr(val.CreateDate, 'full');
						val.bookingDate = baseTool.formatDateStr(val.bookingDate, 'full');
					});
					this.appointOrderList = result.data;
				}
				this.changeTabByOrder(
					this.orderList.length > 0 ? this.orderList[0] : null,
					this.scopeOrderList.length > 0 ? this.scopeOrderList[0] : null,
					this.appointOrderList.length > 0 ? this.appointOrderList[0] : null
				);
			});
		},
		// 传入最新的订单，然后决定跳转到哪个TAB
		changeTabByOrder(TicketOrder, ScopeOrder, AppointOrder) {
			if (TicketOrder && !ScopeOrder && !AppointOrder) {
				this.currentTab = 0;
			} else if (!TicketOrder && ScopeOrder && !AppointOrder) {
				this.currentTab = 1;
			} else if (!TicketOrder && !ScopeOrder && AppointOrder) {
				this.currentTab = 2;
			} else if (TicketOrder && ScopeOrder && AppointOrder) {
				if (TicketOrder.CreateDate > ScopeOrder.CreateDate && TicketOrder.CreateDate > AppointOrder.CreateDate) {
					this.currentTab = 0;
				} else if (ScopeOrder.CreateDate > TicketOrder.CreateDate && ScopeOrder.CreateDate > AppointOrder.CreateDate) {
					this.currentTab = 1;
				} else if (AppointOrder.CreateDate > TicketOrder.CreateDate && AppointOrder.CreateDate > ScopeOrder.CreateDate) {
					this.currentTab = 2;
				}
			}
		},
		applyRefund(order, index) {
			let that = this;
			if (order != undefined) {
				if (order.OrderNum.indexOf('S') == -1 && order.OrderNum.indexOf('A') == -1) {
					paymentApi.userRefundTicketOrder(this.$store.state.user.OpenId, order.ID).then(sucRes => {
						if (sucRes.success) {
							that.$Message.success(sucRes.message);
							that.getOrderList();
						} else {
							that.$Message.error(sucRes.message);
						}
					});
				} else if (order.OrderNum.indexOf('S') != -1) {
					paymentApi.userRefundScopeOrder(this.$store.state.user.OpenId, order.ID).then(sucRes => {
						if (sucRes.success) {
							that.$Message.success(sucRes.message);
							that.getScopeOrderList();
						} else {
							that.$Message.error(sucRes.message);
						}
					});
				} else if (order.OrderNum.indexOf('A') != -1) {
					paymentApi.userRefundAppointOrder(this.$store.state.user.OpenId, order.ID).then(sucRes => {
						if (sucRes.success) {
							this.$Message.success(sucRes.message);
							this.getAppointOrderList();
						} else {
							this.$Message.error(sucRes.message);
						}
					});
				}
			}
		},
		changeTab(val) {
			this.currentTab = val;
		},
		showOrderDetail(order) {
			if (order.Status) {
				if (order.OrderState == 0) {
					this.$Message.warning('请先完成支付，才能查看订单详情。');
				} else if (order.OrderState == 1 || order.OrderState == 2) {
					this.$router.push({
						name: 'OrderDetailsInfo',
						params: {
							id: order.ID
						}
					});
				} else if (order.OrderState == 4) {
					this.$Message.warning('该笔订单已退款。');
				}
			}
		},
		showScopeOrderDetail(order) {
			if (order.Status) {
				if (order.OrderState == 0) {
					this.$Message.warning('请先完成支付，才能查看订单详情。');
				} else if (order.OrderState == 1 || order.OrderState == 2) {
					this.$router.push({
						name: 'ScopeOrderDetailsInfo',
						params: {
							id: order.ID
						}
					});
				} else if (order.OrderState == 4) {
					this.$Message.warning('该笔订单已退款。');
				}
			}
		},
		showAppointOrderDetail(order) {
			if (order.Status) {
				if (order.OrderState == 0) {
					this.$Message.warning('请先完成支付，才能查看订单详情。');
				} else if (order.OrderState == 1 || order.OrderState == 2) {
					this.$router.push({
						name: 'AppointOrderDetailsInfo',
						params: {
							id: order.ID
						}
					});
				} else if (order.OrderState == 4) {
					this.$Message.warning('该笔订单已退款。');
				}
			}
		},
		cancelOrder(order) {
			this.cancelModal.Show = false;
			if (order.OrderNum.indexOf('S') == -1 && order.OrderNum.indexOf('A') == -1) {
				orderApi.userCancelTicketOrder(this.$store.state.user.OpenId, order.ID).then(sucRes => {
					if (sucRes.success) {
						this.$Message.success(sucRes.message);
						this.getOrderList();
					} else {
						this.$Message.error(sucRes.message);
					}
				});
			} else if (order.OrderNum.indexOf('S') != -1) {
				orderApi.userCancelScopeOrder(this.$store.state.user.OpenId, order.ID).then(sucRes => {
					if (sucRes.success) {
						this.$Message.success(sucRes.message);
						this.getScopeOrderList();
					} else {
						this.$Message.error(sucRes.message);
					}
				});
			} else if (order.OrderNum.indexOf('A') != -1) {
				orderApi.userCancelAppointOrder(this.$store.state.user.OpenId, order.ID).then(sucRes => {
					if (sucRes.success) {
						this.$Message.success(sucRes.message);
						this.getAppointOrderList();
					} else {
						this.$Message.error(sucRes.message);
					}
				});
			}
		},
		paymentOrder(orderItem, Type) {
			wx.miniProgram.getEnv(res => {
				console.log('res=>', res);
				if (res.miniprogram) {
					// 在小程序里
					let url = `../webpayprocess/webpayprocess?ordertype=${Type - 1}&id=${that.orderData.ID}&businessid=2`;
					wx.miniProgram.navigateTo({
						url: url
					});
				} else {
					// 公众号网页
					// if (Type == 3) {
					paymentApi.getWeChatPayParams(this.$store.state.user.OpenId, orderItem.ID, 2, Type - 1).then(sucRes => {
						if (sucRes.success) {
							wx.chooseWXPay({
								timestamp: sucRes.data.timeStamp,
								nonceStr: sucRes.data.nonceStr,
								package: sucRes.data.package,
								signType: sucRes.data.signType,
								paySign: sucRes.data.paySign,
								success: res => {
									this.$Message.success('支付成功！');
									this.getOrderList();
								},
								fail: fail => {
									this.$Message.warning('支付失败！');
									this.getOrderList();
								}
							});
						}
					});
					// } else {
					// 	this.$router.push({
					// 		name: 'PaymentSelector',
					// 		params: {
					// 			id: orderItem.ID,
					// 			type: Type
					// 		}
					// 	});
					// }
				}
			});
		}
	}
};
</script>

<style scoped lang="less">
@import '../style/public';

.my_order_page {
	width: 100%;
	height: 100%;
	// background-color:skyblue;
}
.my_order_list {
	flex: 1;
	overflow-x: hidden;
	overflow-y: auto;
	.flex_wrap(initial, initial, initial, column);
}

.my_order_page .tab_swiper {
	flex: 1;
	width: 100%;
	margin-top: 0.3rem;
	/*overflow: auto;*/
}
.record_list_wrap {
	height: 100%;
	overflow-y: auto;
	// display: flex !important;
	// flex-direction: column;
}
.no_record {
	height: 6vh;
	line-height: 6vh;
	text-align: center;
}
.no_record .iconfont {
	font-size: 0.45rem;
	margin: 2px 5px 0 0;
}
.record_list_wrap > .record_wrap:last-child {
	margin: 10px auto !important;
}
.record_wrap {
	width: 94%;
	margin: 10px auto 0;
	/*margin-top: 3%;*/
	border: 1px solid #ccc;
	box-shadow: 0 0 5px #ccc;
	border-radius: 6px;
	background-color: #fff;
	/* font-size: 24rpx */
}
.record_title,
.record_conrainer,
.order_list_foot {
	/*width: 94%;*/
}
.record_title {
	/*margin: 10px auto 0;*/
	height: 5vh;
	align-items: center;
	border: solid #0e6da0;
	border-width: 1px 0;
	border-radius: 6px 6px 0 0;
	background-color: #006535;
	padding: 0 3%;
}
.record_title,
.order_list_foot {
	.flex_wrap(space-between);
}
.record_conrainer,
.order_list_foot {
	background-color: #fff;
	/*border: 1px solid #ccc;*/
	/*border-radius: 5px;*/
	/*box-shadow: 0 0 5px #ccc;*/
	margin: 0 auto;
}
.record_conrainer {
	padding: 1% 3%;
}
.my_order_function_btns {
	.flex_wrap(flex-end, center);
	button {
		.radius;
		.blockPadding(0, 5px);
	}
	.function_btn_pj_color {
		background-color: #e42121;
		color: #fff;
	}
	.function_btn_pj_color:active {
		background-color: #cc1e1e;
		color: #e4e4e4;
	}
}
.my_order_function_btns,
.warm-prompt > p {
	padding: 0.5em;
	border-top: 1px solid #ddd;
	/*border-radius: 0 0 6px 6px;*/
}
.my_order_function_btns .little_btn {
	font-size: 0.3rem !important;
	letter-spacing: normal;
	text-indent: inherit;
	margin: 0;
	margin-right: 5px;
	border-color: transparent;
	/*padding: 3px 4px;*/
}
.my_order_function_btns .little_btn .iconfont {
	margin-left: 0;
	margin-right: 5px;
}
.warm-prompt > p {
	text-align: center;
}
.record_conrainer > p {
	line-height: 4vh;
}
.order_list_foot {
	/*height: 5vh;*/
	border-radius: 0 0 6px 6px;
	border-top: 1px dashed #ccc;
	line-height: 5vh;
	padding: 0 3%;
}
</style>



// WEBPACK FOOTER //
// src/components/MyOrderList.vue